import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ForgotPassword {
  loading: boolean;
  error: string | null;
  ForgotScreen: string;
}

const initialState: ForgotPassword = {
  loading: false,
  error: null,
  ForgotScreen: 'login',
};

const forgotPasswordSlice = createSlice({
  name: 'forgotPassword',
  initialState,
  reducers: {
    setForgotScreen: (state, action: PayloadAction<any>) => {
      state.ForgotScreen = action.payload;
    },
  },
});

// Export the actions, if there are any
export const { setForgotScreen } = forgotPasswordSlice.actions;

// Export the reducer
export default forgotPasswordSlice.reducer;
